import type { AccountDrawerProps } from './components/account-drawer';

import { Iconify } from 'src/components/iconify';
import { paths } from 'src/routes/paths';

// ----------------------------------------------------------------------

/**
 * Kontodrawern bakom avataren. Här bor det som hör till *användaren* snarare än
 * till den valda organisationen — inklusive vilka organisationer kontot tillhör,
 * som tidigare låg felplacerad i sidomenyns "Om föreningen".
 */
export const _account: AccountDrawerProps['data'] = [
  { label: 'Hem', href: paths.dashboard.root, icon: <Iconify icon="solar:home-angle-bold-duotone" /> },
  {
    label: 'Profil',
    href: paths.dashboard.user.edit,
    icon: <Iconify icon="custom:profile-duotone" />,
  },
  {
    label: 'Mina organisationer',
    href: paths.dashboard.organisation.mina,
    icon: <Iconify icon="solar:buildings-3-bold-duotone" />,
  },
  {
    label: 'Kontoinställningar',
    href: paths.dashboard.kontoinställningar,
    icon: <Iconify icon="solar:settings-bold-duotone" />,
  },
];
